/** Utilidades compartidas para formulario de cotización (importación / exportación). */

export const emptyLineaConcepto = () => ({
  key: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
  conceptoId: null,
  conceptoNombre: '',
  detalle: '',
});

export const emptyProducto = () => ({
  key: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
  productoId: null,
  lineasConcepto: [emptyLineaConcepto()],
});

/** Convierte respuesta API (productos[]) al estado del formulario. */
export const productosFromApi = (data) => {
  const bloques = data?.productos;
  if (Array.isArray(bloques) && bloques.length > 0) {
    return bloques.map((p) => ({
      key: `cotp-${p.id ?? p.productoId}`,
      productoId: p.productoId,
      lineasConcepto: (p.conceptos || []).map((c) => ({
        key: `cotc-${c.id}`,
        conceptoId: c.conceptoId,
        conceptoNombre: c.nombre || '',
        detalle: c.detalle != null ? String(c.detalle) : '',
      })),
    }));
  }
  if (data?.productoId != null) {
    return [
      {
        key: 'legacy-producto',
        productoId: data.productoId,
        lineasConcepto: (data.conceptos || []).map((c) => ({
          key: `cotc-${c.id}`,
          conceptoId: c.conceptoId,
          conceptoNombre: c.nombre || '',
          detalle: c.detalle != null ? String(c.detalle) : '',
        })),
      },
    ];
  }
  return [emptyProducto()];
};

/** Valida y arma payload { productos: [{ productoId, conceptos }] }. */
export const buildProductosPayload = (productosBloques) => {
  const productos = [];
  for (const bloque of productosBloques) {
    if (bloque.productoId == null) {
      return { error: 'Selecciona el producto en cada bloque o quita los bloques vacíos' };
    }
    const lineasValidas = (bloque.lineasConcepto || []).filter((l) => l.conceptoId);
    if (!lineasValidas.length) {
      return { error: 'Cada producto debe tener al menos un concepto seleccionado' };
    }
    if (lineasValidas.length !== (bloque.lineasConcepto || []).length) {
      return {
        error: 'Completa el concepto en todas las filas de cada producto o quita las vacías',
      };
    }
    productos.push({
      productoId: bloque.productoId,
      conceptos: lineasValidas.map((l) => ({
        conceptoId: l.conceptoId,
        conceptoNombre: l.conceptoNombre,
        detalle: l.detalle || '',
      })),
    });
  }
  if (!productos.length) {
    return { error: 'Agrega al menos un producto' };
  }
  return { productos };
};

/** Filas de resumen / grilla: una fila por producto con conceptos visibles en grilla. */
export const filasResumenDesdeProductos = (
  clienteSeleccionado,
  productosBloques,
  productosCatalogo,
  conceptosCatalogo,
  aprobada
) => {
  if (!clienteSeleccionado) return [];
  return productosBloques
    .filter((b) => b.productoId != null)
    .map((bloque) => {
      const prod = productosCatalogo.find((p) => p.id === bloque.productoId);
      const row = {
        key: bloque.key,
        cuit: clienteSeleccionado.cuit || '—',
        nombreCliente: clienteSeleccionado.nombre || '—',
        posicionArancelaria: prod?.posicionArancelaria || '—',
        nombreProducto: prod?.nombreProducto || '—',
        aprobada,
      };
      (bloque.lineasConcepto || []).forEach((line) => {
        if (!line.conceptoId) return;
        const c = conceptosCatalogo.find((x) => x.id === line.conceptoId);
        if (c && c.muestraEnGrilla !== false) {
          row[`concepto_${line.key}`] = line.detalle?.trim() || '—';
          row[`concepto_nombre_${line.key}`] = line.conceptoNombre || 'Concepto';
        }
      });
      return row;
    });
};

/** Títulos de columnas de conceptos para grilla de resumen del formulario (borrador). */
export const titulosConceptosDesdeFilas = (filas) => {
  const ordenPorNombre = new Map();
  filas.forEach((c) => {
    (c.conceptosGrilla || []).forEach((l) => {
      const nombre = l.nombre;
      if (!nombre) return;
      const orden = l.orden ?? 0;
      if (!ordenPorNombre.has(nombre)) ordenPorNombre.set(nombre, orden);
      else ordenPorNombre.set(nombre, Math.min(ordenPorNombre.get(nombre), orden));
    });
  });
  return Array.from(ordenPorNombre.entries())
    .sort((a, b) => a[1] - b[1] || String(a[0]).localeCompare(String(b[0])))
    .map(([nombre]) => nombre);
};
